import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import ErrorPage from "../../Error/ErrorPage";
import { AllowedAdministrationRoles } from '../config/administrationConfig';
import { useAuthContext } from '../contexts/AuthContext';
import { UserRoles } from '../models/enums';
import {insuranceRoles} from "../config/securityConcept";

interface PrivateRouteProps {
    children: React.ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
    const { isAuth, isError, role } = useAuthContext();
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;

    useEffect(() => {
        if (path === "/admin" && (!role || !AllowedAdministrationRoles.includes(role))) {
            navigate("/dashboard", { replace: true });
        }
        if (role === UserRoles.admin && path !== "/admin") {
            navigate("/admin", { replace: true });
        }

        if (insuranceRoles.includes(role as UserRoles) && path === "/dashboard/event/new") {
            navigate("/dashboard", { replace: true });
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [path]);

    if (isError) {
        return <ErrorPage />;
    }

    if (!isAuth) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default PrivateRoute;
